import { fromJS } from 'immutable';
import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_FORM_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    whatExpensesAreYouClaimingFor: [],

    // Doctor Visit fields
    doctorVisitTelemedicine: '',
    doctorVisitAnnualPhysicalExam: '',
    doctorVisitFirstVisit: '',
    doctorVisitFollowUp: '',
    doctorVisitFollowUpFracture: '',
    doctorVisitSTIVaccinationsTBEyeExam: '',
    doctorVisitSTITesting: false,
    doctorVisitVaccinationsTBTesting: false,
    doctorVisitEyeExamination: false,
    infoAnnualPhysicalExamItems: [],
    infoOutpatientPhysicianFeesItems: [],
    infoFollowUpVisitItems: [],
    infoFollowUpFractureItems: [],
    infoSTITestingItems: [],
    infoVaccinationsTBTestingItems: [],
    infoEyeExaminationItems: [],
    infoTelemedicineItems: [],

    // Diagnostic Tests fields
    infoDiagnosticTestsItems: [],

    // Prescription Drugs fields
    infoPrescriptionDrugsItems: [],

    // Ambulance Services fields
    ambulanceGroundService: '',
    ambulanceAirService: '',
    infoGroundAmbulanceItems: [],
    infoAirAmbulanceItems: [],

    // Hospitalization fields
    hospitalizationHospitalInvoice: false,
    hospitalizationPhysicianInvoice: false,
    hospitalizationLabDiagnostic: false,
    hospitalizationOtherRelated: false,
    hospitalizationMentalHealthPsychiatric: false,
    hospitalizationEmergencyAirTransportation: false,
    hospitalizationAirfareReturnHome: false,
    hospitalizationFamilyTransportation: false,
    hospitalizationMedicalAttendant: false,
    infoHospitalFeesItems: [],
    infoInpatientPhysicianFeesItems: [],
    infoXrayLabsDiagnosticsItems: [],
    infoOtherHospitalizationItems: [],
    infoMentalHealthPsychiatricItems: [],
    infoEmergencyAirTransportationItems: [],
    infoAirfareReturnHomeItems: [],
    infoFamilyTransportationItems: [],
    infoMedicalAttendantItems: [],

    // Essential Medical Appliances fields
    infoEssentialMedicalAppliancesItems: [],

    // Return of Vehicle fields
    returnOfVehicleCommercialAgency: false,
    returnOfVehicleFamilyMemberFriend: false,
    infoReturnOfVehicleCommercialAgencyItems: [],
    infoReturnOfVehicleFamilyMemberFriendItems: [],

    // Private Duty Nursing fields
    infoPrivateDutyNursingItems: [],

    // Fracture Treatment fields
    infoFractureTreatmentItems: [],

    // Maternity Benefits fields
    maternityBenefitsDateOfConception: '',
    maternityBenefitsAnticipatedDueDate: '',
    maternityBenefitsRoutinePreNatalCare: false,
    maternityBenefitsComplicationsOfPregnancy: false,
    maternityBenefitsInvoluntaryTermination: false,
    infoRoutinePreNatalCareItems: [],
    infoComplicationsOfPregnancyItems: [],
    infoInvoluntaryTerminationItems: [],

    // Professional Services fields
    professionalServicesPhysiotherapist: false,
    professionalServicesChiropractor: false,
    professionalServicesChiropodist: false,
    professionalServicesOsteopath: false,
    professionalServicesPodiatrist: false,
    professionalServicesAcupuncturist: false,
    professionalServicesNaturopath: false,
    professionalServicesSpeechTherapist: false,
    professionalServicesMentalHealthOrSupportPractitioner: false,
    infoPhysiotherapistItems: [],
    infoChiropractorItems: [],
    infoChiropodistItems: [],
    infoOsteopathItems: [],
    infoPodiatristItems: [],
    infoAcupuncturistItems: [],
    infoNaturopathItems: [],
    infoSpeechTherapistItems: [],
    infoMentalHealthOrSupportPractitionerItems: [],

    // Rehabilitation Treatment fields
    infoRehabilitationTreatmentItems: [],

    // Dental Services fields
    dentalServicesDentalAccident: false,
    dentalServicesImpactedWisdomTooth: false,
    dentalServicesDentalPainOther: false,
    infoDentalAccidentItems: [],
    infoImpactedWisdomToothItems: [],
    infoDentalPainOtherItems: [],

    // Prescription Glasses, Contact Lenses or Hearing Aids fields
    infoPrescriptionGlassesContactLensesHearingAidsItems: [],

    // Tutorial Services fields
    infoTutorialServicesItems: [],

    // Other (unrelated to any benefit listed above)
    infoOtherUnrelatedBenefitItems: [],
  },
  errors: [],
});

function handleFormReset(state, { fields }) {
  // Only reset the specified fields to empty arrays or default values
  let newState = state;
  fields.forEach((field) => {
    // Get the default value from initialState for this field
    const defaultValue = initialState.getIn(['form', field]);
    // Reset the field to its default value (empty array [] or empty string '')
    newState = newState.setIn(['form', field], defaultValue);
  });

  return newState;
}

function studentMedicalBenefitsTugoReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_FORM_STATE:
      return handleFormReset(state, action.payload);
    default:
      return state;
  }
}

export default studentMedicalBenefitsTugoReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StudentMedicalBenefits/reducer.js